const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000/api';

export interface SponsorshipInquiryInput {
  name: string;
  company: string;
  email: string;
  phone: string;
  tier: string;
  message: string;
}

export class SponsorshipInquiryError extends Error {}

export async function submitSponsorshipInquiry(input: SponsorshipInquiryInput): Promise<void> {
  const res = await fetch(`${API_URL}/sponsorship-inquiries`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => null);
    const firstError = data?.errors ? Object.values(data.errors)[0] : null;
    const message = Array.isArray(firstError) ? firstError[0] : data?.message;
    throw new SponsorshipInquiryError(message || 'Could not send your inquiry. Please try again.');
  }
}
